<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #ac8400">TBA Content Listing</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #f2f2f2">
      <router-link to="/dashboard"> Dashboard </router-link>
      /

      <b>TBA</b> / <b>Content Listing</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="pt-3 pb-3">
      <b>
        Note: Admins can upload a document and photo with description and price
        on behalf of the client's policy via the dashboard. Reuploading a new
        file will overwrite the previously uploaded document.
      </b>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4" v-if="showCertificateInput">
        <div class="card text-left">
          <div class="card-body">
            <h4><b>Certificate Number</b></h4>
            <div class="row mb-3">
              <div class="col-5">
                <input
                  type="text"
                  v-model="details.certificate_no"
                  class="form-control"
                />
              </div>

              <div class="col-1">
                <div class="float-left">
                  <button
                    class="btn btn-primary btn-wide"
                    @click="storeCertificateNo()"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4><b>Upload Document</b></h4>
            <div class="row">
              <div class="col-8">
                <input
                  type="file"
                  id="file"
                  ref="fileUpload"
                  @change="handleFileUpload"
                  class="inputfile"
                />
              </div>

              <div class="col-2">
                <div class="float-right">
                  <button
                    class="btn btn-primary btn-wide mt-4"
                    @click="popUp()"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4><b>Uploaded Documents</b></h4>
            <div class="table-responsive">
              <table
                id="content_table"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Uploaded On</th>
                    <th>File</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="document && document.id">
                    <td>1</td>
                    <td>{{ document.created_at }}</td>
                    <td
                      style="text-decoration: underline"
                      class="cursor-pointer text-primary"
                      @click="downloadDocument(document.id)"
                    >
                      CHP Document
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4><b>Upload Photos</b></h4>
            <div
              class="row pb-4"
              v-for="(photo, photoIndex) in photos"
              :key="photoIndex"
            >
              <div class="col-4">
                <div class="form-group">
                  <div v-if="photo.file_name && !photo.newFile">
                    <label>Photo</label>
                    <input
                      type="text"
                      v-model="photo.file_name"
                      class="form-control"
                      disabled
                    />
                  </div>

                  <div v-else>
                    <input
                      type="file"
                      @change="handlePhotoUpload($event, photoIndex)"
                      class="inputfile"
                    />
                  </div>
                </div>
              </div>
              <div class="col-2">
                <button
                  class="btn"
                  style="background-color: #8c1919; color: white"
                  @click="removePhoto(photoIndex, photo ? photo.id : null)"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>

              <hr />
            </div>

            <button class="btn btn-primary" @click="addPhotoRow()">Add</button>

            <br />

            <button
              class="btn btn-primary float-right"
              @click="storeUploadPhotos()"
            >
              Upload
            </button>
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4><b>Uploaded Photos</b></h4>
            <div class="table-responsive">
              <table
                id="content_table"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Uploaded On</th>
                    <th>Image</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(photo, photoIndex) in photos" :key="photoIndex">
                    <td>{{ photoIndex + 1 }}</td>
                    <td>{{ photo.created_at }}</td>
                    <td
                      style="text-decoration: underline"
                      class="cursor-pointer text-primary"
                      @click="downloadDocument(photo.id)"
                    >
                      {{ photo.file_name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4><b>Activity Log</b></h4>
            <div class="table-responsive">
              <table
                id="activity_log_table"
                class="display table table-striped table-bordered"
                style="width: 100%; text-align: center"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>User</th>
                    <th>Description</th>
                    <th>Timestamp</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(log, logIndex) in logs" :key="logIndex">
                    <td>{{ logIndex + 1 }}</td>
                    <td>{{ log.user.name }}</td>
                    <td class="text-left">{{ log.description }}</td>
                    <td>{{ log.created_at }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getActivityLogs,
  getContentCoverageDetail,
  removePhoto,
  storeDetail,
  storeCertificateNoRequest,
} from "../../../services/ContentCoverageService";
import { global } from "@/global";
import Button from "../../../components/UI/Button.vue";

export default {
  name: "content-listing-view",
  components: { Button },

  data() {
    return {
      id: null,
      fileUpload: "",
      details: [],
      document: [],
      logs: [],
      photos: [
        {
          id: null,
          file_name: null,
          url: null,
          description: null,
          price: null,
          details: {},
          newFile: false,
        },
      ],
      showCertificateInput: false,
    };
  },

  methods: {
    handleFileUpload() {
      this.fileUpload = this.$refs.fileUpload.files[0];
    },

    handlePhotoUpload(event, index) {
      const fileList = event.target.files;
      if (fileList && fileList.length > 0) {
        this.photos[index].file = fileList[0];
        // Include current details in the photo object
        this.photos[index].details = { ...this.details };
      }
    },

    addPhotoRow() {
      this.photos.push({
        file: null,
        description: "",
        price: null,
        details: { ...this.details },
      });
    },

    async removePhoto(index, photoId = null) {
      this.photos.splice(index, 1);

      if (!photoId) {
        return;
      }

      try {
        await removePhoto(photoId);
      } catch (e) {
        console.log(e);
      }
    },

    resetPhotoFile(index) {
      this.photos[index].file = null;
      this.photos[index].file_name = null;
      this.photos[index].newFile = false;
    },

    async loadDetails() {
      try {
        const response = await getContentCoverageDetail(this.id);
        if (response.data.success) {
          this.details = response.data.data;
          this.document = this.details.document;
          this.photos = this.details.photos;

          this.showCertificateInput =
            !this.details.certificate_no || this.details.certificate_no == "";
        }
      } catch (error) {
        console.error(error);
      }
    },

    downloadDocument(id) {
      const url = `${global.base_url}/api/medias/${id}/download`;
      window.open(url, "_blank", "noopener,noreferrer");
    },

    async storeUploadDocument() {
      const formData = new FormData();

      // Append all top-level user fields except the document file
      for (const key in this.details) {
        if (key != "document" && key != "photos") {
          formData.append(key, this.details[key]);
        }
      }

      if (this.fileUpload) {
        formData.append("document", this.fileUpload); // actual file
      }

      try {
        const response = await storeDetail(formData);

        swal({
          title: response.data.success ? "Success" : "Failed",
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
        });

        this.loadDetails();
      } catch (e) {
        console.log(e);
      }
    },

    async storeUploadPhotos() {
      const formData = new FormData();

      // Append all top-level user fields except the document file
      for (const key in this.details) {
        if (key != "document" && key != "photos") {
          formData.append(key, this.details[key]);
        }
      }

      this.photos.forEach((photo, index) => {
        // Append photo file if selected
        if (photo.file) {
          formData.append(`photos[${index}][image]`, photo.file);
        }

        // Append description and price
        formData.append(
          `photos[${index}][description]`,
          photo.description || ""
        );
        formData.append(`photos[${index}][price]`, photo.price || 0);

        // Append the top-level details for each photo
        if (photo.details) {
          for (const key in photo.details) {
            formData.append(
              `photos[${index}][details][${key}]`,
              photo.details[key]
            );
          }
        }
      });

      try {
        const response = await storeDetail(formData);

        swal({
          title: response.data.success ? "Success" : "Failed",
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
        });

        this.loadDetails();
      } catch (e) {
        console.log(e);
      }
    },

    async loadLogs() {
      try {
        const response = await getActivityLogs(this.id);
        if (response.data.success) {
          this.logs = response.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async storeCertificateNo() {
      let data = {
        id: this.id,
        certificate_no: this.details.certificate_no,
      };

      try {
        const response = await storeCertificateNoRequest(data);

        swal({
          title: response.data.success ? "Success" : "Failed",
          icon: response.data.success ? "success" : "error",
          text: response.data.message,
        });

        this.loadDetails();
      } catch (e) {
        console.log(e);
      }
    },

    async popUp() {
      swal({
        icon: "info",
        text: "Are you sure you want to proceed? Re-uploading will overwrite the existing document, and this action cannot be undone.",
        buttons: ["Cancel", "Yes"],
      }).then((confirm) => {
        if (confirm) {
          this.storeUploadDocument();
        }
      });
    },
  },

  async created() {
    this.id = this.$route.params.id;

    await this.loadDetails();
    await this.loadLogs();

    setTimeout(function () {
      $("#activity_log_table").DataTable({
        dom: "Bfrtip",
        buttons: ["excel", "pdf"],
      });
    }, 1000);
  },
};
</script>


<style scoped>
input[type="file"]::file-selector-button {
  margin-right: 20px;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
  background-color: #ac8400;
  border-color: #ac8400;

  /* cursor: pointer; */
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  color: #fff;
  background-color: #806200;
  border-color: #b38900;
}

.cursor-pointer {
  cursor: pointer;
  font-weight: bold;
}
</style>
